import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deletePersonalizedSlipTemplate = {
  name: "deletePersonalizedSlipTemplate" as const,
  input: z.object({ templateId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
